module.exports = __webpack_public_path__ + "img/KUCE-CROP-05.f8d4ee68.png";